export function throwIfAborted(signal: AbortSignal) {
  if (signal.aborted) {
    throw new Error('AbortSignal was aborted, reason ' + signal.reason)
  }
}
